<template>
  <div class="ufi-card primaryFont">
    <h3 class="title" :style="{ fontSize: titleSize }">{{ title }}</h3>
    <apexchart type="radialBar" height="300" :options="chartOptions" :series="series" />
  </div>
</template>

<script setup>
import { ref } from "vue";

const props = defineProps({
  title: { type: String, required: true },
  series: { type: Array, required: true },
  labels: { type: Array, required: true },
  titleSize: {
    type: String,
    default: "32px",
  },
});

const chartOptions = ref({
  chart: {
    type: "radialBar",
    offsetY: 0,
    sparkline: { enabled: true },
  },
  plotOptions: {
    radialBar: {
      offsetY: 0,
      startAngle: 0,
      endAngle: 270,
      hollow: {
        margin: 5,
        size: "30%",
        background: "transparent",
        image: undefined,
      },
      track: {
        background: "#f0f0f0",
        strokeWidth: "100%",
        margin: 5,
      },
      dataLabels: {
        name: {
          show: false,
        },
        value: {
          show: false,
        },
      },
      barLabels: {
        enabled: true,
        useSeriesColors: true,
        offsetX: -8,
        fontSize: "13px",
        style: {
          fontFamily: "IBM Plex Sans, sans-serif",
        },
        fontWeight: 500,
        formatter: function (seriesName, opts) {
          return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex];
        },
      },
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          show: false,
        },
      },
    },
  ],
  labels: props.labels,
  colors: ["#3AC0EB", "#2494FD", "#546BAA"],
  legend: {
    show: false,
  },
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;600&display=swap");

.ufi-card {
  max-width: 260px;
  min-height: 310px;
  background: #ffffff;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 4px 12px #00000040;
  text-align: center;
}

.title {
  color: #09447c;
  font-weight: 700;
  margin: 0;
  min-height: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
